import { createAction, createSlice } from '@reduxjs/toolkit';


export const loadInsightsRequest = createAction('insights/loadInsightsRequest');

const insightsSlice = createSlice({
    name: 'insights',
    initialState: {},
    reducers: {
        fetchInsightsStart: (state, action) => {
            const key = action.payload;
            if (!state[key]) {
                state[key] = {
                    cards: [],
                    graphs: {},
                    loading: true,
                    error: null,
                };
            } else {
                state[key].loading = true;
                state[key].error = null;
            }
        },
        fetchInsightsSuccess: (state, action) => {
            const { key, data } = action.payload;
            const { cards, graphs } = data || {};
            state[key] = {
                cards: Array.isArray(cards) ? cards : [],
                graphs: graphs ? graphs : {},
                loading: false,
                error: null,
            };
        },
        fetchInsightsFailure: (state, action) => {
            const { key, error } = action.payload;
            if (!state[key]) {
                state[key] = {
                    cards: [],
                    graphs: {},
                    loading: false,
                    error: 'Key not found',
                };
            } else {
                state[key].loading = false;
                state[key].error = error || 'Something went wrong';
            }
        }
    },
});

export const {
    fetchInsightsStart,
    fetchInsightsSuccess,
    fetchInsightsFailure,
} = insightsSlice.actions;

export default insightsSlice.reducer;
